module.exports = __webpack_public_path__ + "static/media/bolinhas.b835dad8.svg";